import React from "react";
import PolicyEnforcementRules from "./PolicyEnforcementRules";

function PolicyEnforcementRulesView() {
  return <PolicyEnforcementRules />;
}

export default PolicyEnforcementRulesView;
